import React from 'react'
import PropTypes from 'prop-types'
import { Tag, Tooltip } from 'antd'

// Resolve an API identity row to what should be shown (spec: whatsapp-bsuid-support). Some users now
// contact us without exposing a phone number — only a Business-Scoped User ID (BSUID) and optionally
// a @username. Returns { kind, text, tooltip } where kind is:
//   'phone'    → a masked phone (phoneMasked / waIdMasked), shown as plain text
//   'username' → a @username handle, shown as a Tag (visually distinct from a phone)
//   'text'     → the API's displayIdentity (profile/MoMo name, or a short BSUID reference)
//   'empty'    → nothing known
// A username is NEVER returned in phone form. Exported for unit testing.
export const resolveIdentity = value => {
  if (!value) return { kind: 'empty', text: '—', tooltip: null }
  const masked = value.phoneMasked || value.waIdMasked
  if (masked) return { kind: 'phone', text: masked, tooltip: null }
  if (value.username) return { kind: 'username', text: `@${value.username}`, tooltip: null }
  return {
    kind: 'text',
    text: value.displayIdentity || '—',
    tooltip: value.bsuid || null
  }
}

// Renders a WhatsApp sender identity from an API row carrying
// { phoneMasked | waIdMasked, username, displayIdentity, bsuid }.
const IdentityLabel = ({ value, strong = false }) => {
  const { kind, text, tooltip } = resolveIdentity(value)
  if (kind === 'username') {
    return (
      <Tag color="blue" style={{ marginInlineEnd: 0 }}>
        {text}
      </Tag>
    )
  }
  const node = strong ? <strong>{text}</strong> : <span>{text}</span>
  return tooltip ? <Tooltip title={tooltip}>{node}</Tooltip> : node
}

IdentityLabel.propTypes = {
  value: PropTypes.object,
  strong: PropTypes.bool
}

export default IdentityLabel
